// Splide
import Splide from '@splidejs/splide';

// Initiate splide slider for hero section
export const initHeroSectionSplide = (containerEl: HTMLElement) => {
  if (!containerEl) return;

  const isAutoPlay: boolean = containerEl.getAttribute("data-autoplay") == "True" ? true : false;
  const selectedInterval: number = containerEl.getAttribute("data-interval")?.length > 0 ? Number(containerEl.getAttribute("data-interval")) : 5000;

  var heroSplide = new Splide( containerEl, {
      type: 'loop',
      autoplay: isAutoPlay,
      interval: selectedInterval,
      resetProgress: false
  } );

  heroSplide.on( 'overflow', function ( isOverflow ) {
      heroSplide.options = {
        arrows: isOverflow,
        drag: isOverflow
      };
    } );

  heroSplide.mount();
}